import { CSSProperties } from 'react';
import { ModalButton } from 'components/common';
import { CourseShare } from 'components/courses/common';
import { useReduxState } from 'hooks';

const CourseHeaderShare = ({ style }: { style?: CSSProperties }) => {
  const {
    messages,
    pageState: { course }
  } = useReduxState();

  return (
    <ModalButton
      aria-label={messages.commonShare}
      data-tooltip={messages.commonShare}
      category="light"
      icon="share"
      iconStyle={{
        fontSize: '1.3rem',
        position: 'relative',
        top: 1,
        paddingBottom: 1
      }}
      modalProps={{
        closeButton: true,
        title: messages.commonShare,
        width: 'wide'
      }}
      size="small"
      style={style}
    >
      <div className="content">
        <CourseShare course={course} showDownloadButton={true} />
      </div>
    </ModalButton>
  );
};

export default CourseHeaderShare;
